import { render, staticRenderFns } from "./toggleText.vue?vue&type=template&id=5f5d561e&"
import script from "./toggleText.vue?vue&type=script&lang=js&"
export * from "./toggleText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports